import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon, Image } from "react-bootstrap";
import { format } from 'date-fns';
import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw } from 'draft-js';


const convertDraftToHtml = (rawContent) => {
    try {
        const contentState = convertFromRaw(JSON.parse(rawContent));
        return stateToHTML(contentState);
    } catch (error) {
        console.error("Ошибка конвертации Draft.js в HTML:", error);
        return rawContent; 
    }
};

const renderRow = (promoModel, onEdit, isReadOnly, onDelete) => {
    const imageUrl = `api/settings/promo/image/${promoModel.Id}?t=${new Date().getTime()}`;

    return (
        <tr key={promoModel.Id}>
            <td>{promoModel.Id}</td>
            <td>{promoModel.Name}</td>
            <td dangerouslySetInnerHTML={{ __html: convertDraftToHtml(promoModel.Description) }}></td>
            <td>
                <Glyphicon 
                    glyph='trash' 
                    className={`glyphicon-trash${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onDelete(promoModel)} 
                    title='Удалить' />
            </td>
            <td>
                <Glyphicon 
                    glyph='pencil' 
                    className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onEdit(promoModel)} 
                    title='Изменить' />
            </td>
        </tr>
    );
};

export const Table = ({ promos, fetching, onEdit, isReadOnly, onDelete }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>№</td>
                        <td>Название</td>
                        <td>Описание</td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {promos.map(d => renderRow(d, onEdit, isReadOnly, onDelete))}
                </tbody>
            </table>}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/settings/promo/Table.jsx